// Presenter mode: guided demo steps and a tiny command bus to drive the Ceres widget.
const FLAG = "ceres_presenter";
const STEP_KEY = "ceres_presenter_step";

export const STEPS = [
  { title: "Meet Ceres on harvestportfolios.com", path: "/", action: "open",
    say: "Ceres lives on every Harvest page, bottom right, in Harvest's own brand. It answers only from Harvest's published content." },
  { title: "Fund card in one question", path: "/", action: "ask", prompt: "Tell me about HHL",
    say: "A full fund card: price, yield, monthly distribution, risk rating, fee, class tabs and the as-at date, with numbered sources." },
  { title: "Side-by-side comparison", path: "/", action: "ask", prompt: "Compare HTA and HTAE",
    say: "Advisors get a comparison table with standard performance periods, and the leverage note for the Enhanced fund." },
  { title: "Page-aware on a fund page", path: "/etf/hhl/", action: "ask", prompt: "When is the next distribution paid?",
    say: "On the HHL page Ceres knows the context, so a question without a ticker is about HHL." },
  { title: "Asks before it guesses", path: "/", action: "ask", prompt: "When does the Nvidia ETF pay?",
    say: "Two Harvest funds hold Nvidia, so Ceres asks NVHE or NVDH, then gives the High Income Shares™ schedule." },
  { title: "Compliance: no personal advice", path: "/", action: "ask", prompt: "Should I put my RRSP in HHIS?",
    say: "Neutral facts only, a pointer to a licensed advisor and the standard Harvest disclaimer." },
  { title: "Bilingual", path: "/", action: "ask", prompt: "Qu'est-ce qu'un appel couvert?",
    say: "Ceres answers in French automatically, with a source." },
  { title: "What's new from Harvest", path: "/", action: "ask", prompt: "What's new from Harvest this month?",
    say: "The latest launches, press releases and Insights, newest first, each with its date." },
  { title: "Fund Finder", path: "/", action: "finder",
    say: "Three neutral questions filter Harvest funds by published facts. It's discovery, not a recommendation." },
  { title: "Advisor Brief and share link", path: "/", action: "open",
    say: "Under any answer: the page icon creates a one-page branded PDF, prepared for a client; the link icon copies a shareable answer page." },
  { title: "Voice mode", path: "/", action: "voice",
    say: "Hands-free: ask out loud, Ceres answers in a short spoken reply, and you can talk over it anytime." },
  { title: "The Ceres page", path: "/chat", action: null,
    say: "Ceres also has its own page, with the Harvest-to-Ceres intro, for campaigns and advisor portals." },
  { title: "Insights for Harvest", path: "/admin", action: null,
    say: "The dashboard shows top questions, most-asked tickers, content gaps, thumbs-down transcripts, EN/FR split and Advisor Brief downloads. Sample data for the demo." },
];

export const presenter = {
  on: () => sessionStorage.getItem(FLAG) === "1",
  start: () => { sessionStorage.setItem(FLAG, "1"); sessionStorage.setItem(STEP_KEY, "0"); },
  stop: () => { sessionStorage.removeItem(FLAG); sessionStorage.removeItem(STEP_KEY); },
  step: () => Number(sessionStorage.getItem(STEP_KEY) || 0),
  setStep: (i) => sessionStorage.setItem(STEP_KEY, String(i)),
};

let pending = null;
const subs = new Set();
export const demo = {
  run(cmd) { pending = { ...cmd, id: Date.now() }; subs.forEach((f) => f()); },
  take() { const p = pending; pending = null; return p; },
  subscribe(f) { subs.add(f); return () => subs.delete(f); },
};
